<template>
    <transition name="fade">
        <div>
            <section
                class="hero is-secondary is-fullheight"
                animation="fade">
                <div class="hero-body">
                    <div class="container has-text-centered">
                        <h1 class="title">
                            Denn
                        </h1>
                        <a @click="auth()" style="align-items:center;color:#fff;background-color:#4A154B;border:0;border-radius:4px;display:inline-flex;font-family:Lato, sans-serif;font-size:16px;font-weight:600;height:48px;justify-content:center;text-decoration:none;width:256px">
                            <svg xmlns="http://www.w3.org/2000/svg" style="height:20px;width:20px;margin-right:12px" viewBox="0 0 122.8 122.8">
                                <path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a"></path>
                                <path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0"></path>
                                <path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d"></path>
                                <path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e"></path>
                            </svg>
                            Sign in with Slack
                        </a>
                    </div>
                </div>
            </section>
        </div>
    </transition>
</template>

<script>

    import { eventBus } from '../main'
    import axios from 'axios'

    export default {
        data() {
            return {
                // client_id : '10870235813.481360365027', // old 'den' app
                client_id: '10870235813.7838789471511', // new 'denn' app (requires dev https which is a pain)
                redirect_uri : window.location.origin + '/login',
                scope: 'identity.basic identity.team',
                // team: 'T0ARL6XPX', // will auto attempt analog workspace,
            }
        },
        watch: {
            '$route'(to, from) {
                console.info("Auth.vue - to.params.project", to.params.project)
            },
        },
        methods: {
            auth() {
                // Upgrading to heroku stack-22 I replaced vue-authenticate with my own simple code
                
                // create state from current time
                let state =  new Date().getTime().toString()
                
                // forward user to slack authorise url with custom params
                // on redirect mounted() will read the URL queries to try to login
                let slack_auth_url = "https://slack.com/oauth/authorize?response_type=code&client_id=" + this.client_id + "&redirect_uri="+ this.redirect_uri + "&scope=" + this.scope + "&state=" + state + "&team=" + this.team
                console.info('slack_auth_url', slack_auth_url)
                window.location = slack_auth_url
            },
        },
        mounted() {
            // check for 'code' in the URL query which would have been provided after Slacks redirect
            if (this.$route.query.code) {
                console.info('this.$route.query', this.$route.query)
                axios.defaults.xsrfCookieName = 'csrftoken'
                axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

                let post_data = {
                    "clientId" : this.client_id,
                    "code": this.$route.query.code,
                    "state": this.$route.query.state,
                    "redirect_uri": this.redirect_uri
                }

                console.info('posting this to den api social', post_data)

                axios.post(window.location.origin + '/api/login/social/token_user/slack/', post_data).then((response) => {
                    console.info('denn api social response.data', response.data)
                    // if token check is OK
                    if (response.status == "200") {

                        // save localstorage
                        localStorage.setItem('den_loggedin', true)
                        localStorage.setItem('den_user', response.data.first_name + " " + response.data.last_name)
                        localStorage.setItem('den_user_email', response.data.email)
                        localStorage.setItem('den_user_slack_id', response.data.id)
                        localStorage.setItem('den_user_slack_username', response.data.username)
                        
                        // used to be vue-authenticate.vueauth_token
                        localStorage.setItem('den_vueauth_token', response.data.token)
                        // vue-authenticate.null_state was also set by vue-authenticate, but it works without and I dont know its purpose?
                        
                        // refreshes window properly instead of using the router
                        window.location = "/"
                    }
                    else {
                        console.info("window.location.origin + '/api/login/social/token_user/slack/' did not return OK...")
                    }
    
                }).catch((error) => {
                    console.error("simons auth error:", error)
                })

            }
        }
    }
</script>
